import type { LimaSourceAggregatedStatusModel } from '@/pages/Administration/Devices/SyncDevices/SyncDevices.types';

import type {
  CallbackFunctionWithMultiParam,
  DeviceModel
} from '../DevicesTable.types';

export type LimaSourceAggregatedStatusProps = {
  row: LimaSourceAggregatedStatusModel;
  deviceRow: DeviceModel;
  onSourceClicked: CallbackFunctionWithMultiParam;
  isMainDevicePage: boolean;
};

export type MicrosoftDataProvidersAggregatedStatusProps = {
  row: LimaSourceAggregatedStatusModel;
  deviceRow: DeviceModel;
};

export type AggregatedSource = Omit<
  LimaSourceAggregatedStatusModel,
  'highest_status' | 'statusGroups'
> & {
  group_1xxx: number;
  group_2xxx: number;
  group_3xxx: number;
  group_4xxx: number;
  group_null: number;
  [key: string]: string | number | null | undefined;
};

export const STATUS_PRIORITY: Record<string, number> = {
  error: 4,
  warning: 3,
  success: 2,
  disabled: 1,
  unknown: 0
};
